import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

/* Send a post to up to five connections. It lands in your chat with each of
   them as a card they can open, with your note underneath. */
export default function SharePost({ postId, notify, onClose }) {
  const [people, setPeople] = useState(null);
  const [picked, setPicked] = useState([]);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.connections()
      .then((rows) => setPeople(rows.filter((c) => c.active).map((c) => c.other)))
      .catch(() => setPeople([]));
  }, []);

  const toggle = (id) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id)
    : p.length >= 5 ? p : [...p, id]));

  async function send() {
    setBusy(true);
    try {
      const r = await api.sharePost(postId, picked, note.trim());
      notify?.(`Sent to ${r.sent.join(', ')}`);
      onClose();
    } catch (err) {
      notify?.(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="share-post">
      <p className="muted-sm">Send this post to a connection. It arrives in your chat with them.</p>
      {people === null && <p className="muted-sm">Loading your connections…</p>}
      {people?.length === 0 && <p className="muted-sm">You aren't connected to anyone yet.</p>}
      {people?.length > 0 && (
        <div className="share-people">
          {people.map((p) => (
            <label key={p.id} className={`share-person${picked.includes(p.id) ? ' on' : ''}`}>
              <input type="checkbox" checked={picked.includes(p.id)} onChange={() => toggle(p.id)} />
              <span><b>{p.name}</b>{p.headline ? <em> · {p.headline}</em> : null}</span>
            </label>
          ))}
        </div>
      )}
      {picked.length >= 5 && <p className="muted-sm">Up to 5 people at a time.</p>}
      <textarea className="ta" rows={2} maxLength={1000} value={note} onChange={(e) => setNote(e.target.value)}
        placeholder="Add a note (optional) — e.g. thought of you when I saw this" />
      <div className="share-actions">
        <button className="btn primary sm" disabled={!picked.length || busy} onClick={send}>
          {busy ? 'Sending…' : picked.length > 1 ? `Send to ${picked.length}` : 'Send'}
        </button>
        <button className="btn quiet sm" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
